var _path, _path2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendInAdvance2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46346 7.26031L13.8008 4.5C13.9039 3.98252 13.508 3.5 12.9803 3.5H3.04426C2.52396 3.5 2.15092 4.00175 2.30078 4.5L7.53829 7.25696C7.82759 7.40925 8.17306 7.4105 8.46346 7.26031Z",
    fill: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.30904C2 5.93735 2.39118 5.69555 2.72363 5.86177L7.55273 8.27681C7.8342 8.4175 8.1658 8.4175 8.44727 8.27681L13.2764 5.86177C13.6088 5.69555 14 5.93735 14 6.30904V11.5004C13.9998 12.0525 13.5521 12.5004 13 12.5004H3C2.99413 12.5004 2.98827 12.4996 2.98242 12.4995H4.5C5.32843 12.4995 6 11.8279 6 10.9995C5.99999 10.9709 5.9967 10.9427 5.99512 10.9145C6.57975 10.7097 6.99979 10.1549 7 9.50045C7 8.67202 6.32843 8.00045 5.5 8.00045H2.5C2.3245 8.00045 2.15653 8.03197 2 8.08736V6.30904Z",
    fill: "#002A69"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 9,
    width: 5,
    height: 1,
    rx: 0.5,
    fill: "#002A69"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10.5,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendInAdvance2);
export default __webpack_public_path__ + "static/media/Send_in_advance_2.12509e3fbedb8882e551d052f13619ea.svg";
export { ForwardRef as ReactComponent };